import { format, parseISO } from 'date-fns'
import { ReportChart } from '@/components/relatorios/ReportChart'
import { ReportKpiCard } from '@/components/relatorios/ReportKpiCard'
import { ReportShell } from '@/components/relatorios/ReportShell'
import { ReportTable } from '@/components/relatorios/ReportTable'
import { exportCsv, formatCurrency } from '@/components/relatorios/reportUtils'
import { useSalesReport } from '@/hooks/reports/reportHooks'
import { useReportDateRange } from '@/hooks/reports/useReportDateRange'

export default function VendasReport() {
  const [range, setRange] = useReportDateRange()
  const report = useSalesReport(range)
  const won = report.data.rows.reduce((sum, row) => sum + row.won, 0)
  const lost = report.data.rows.reduce((sum, row) => sum + row.lost, 0)
  const revenue = report.data.rows.reduce((sum, row) => sum + row.revenue, 0)

  return (
    <ReportShell
      title="Vendas e motivos de perda"
      description="Fechamentos pela data efetiva da oportunidade."
      {...range}
      onRangeChange={setRange}
      loading={report.loading}
      error={report.error}
      empty={won + lost === 0}
      onRetry={report.refetch}
      onExport={() => exportCsv('vendas', report.data.rows, [
        { label: 'Data', value: (row) => row.date },
        { label: 'Ganhas', value: (row) => row.won },
        { label: 'Perdidas', value: (row) => row.lost },
        { label: 'Receita', value: (row) => row.revenue.toFixed(2).replace('.', ',') },
      ])}
    >
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <ReportKpiCard label="Vendas ganhas" value={won} />
        <ReportKpiCard label="Vendas perdidas" value={lost} />
        <ReportKpiCard label="Receita" value={formatCurrency(revenue)} />
        <ReportKpiCard label="Ticket médio" value={formatCurrency(won ? revenue / won : 0)} />
      </div>
      <ReportChart
        type="bar"
        data={report.data.rows.map((row) => ({ ...row, label: format(parseISO(row.date), 'dd/MM') }))}
        xKey="label"
        series={[
          { key: 'won', label: 'Ganhas', color: 'var(--chart-2)' },
          { key: 'lost', label: 'Perdidas', color: 'var(--chart-5)' },
        ]}
      />
      <div className="grid gap-4 xl:grid-cols-2">
        <ReportTable
          rows={report.data.rows.filter((row) => row.won + row.lost > 0)}
          rowKey={(row) => row.date}
          columns={[
            { key: 'date', label: 'Data', render: (row) => format(parseISO(row.date), 'dd/MM/yyyy') },
            { key: 'won', label: 'Ganhas', align: 'right', render: (row) => row.won },
            { key: 'lost', label: 'Perdidas', align: 'right', render: (row) => row.lost },
            { key: 'revenue', label: 'Receita', align: 'right', render: (row) => formatCurrency(row.revenue) },
          ]}
        />
        <ReportTable
          rows={report.data.lossReasons}
          rowKey={(row) => row.reason}
          columns={[
            { key: 'reason', label: 'Motivo da perda', render: (row) => row.reason },
            { key: 'count', label: 'Quantidade', align: 'right', render: (row) => row.count },
          ]}
        />
      </div>
    </ReportShell>
  )
}
